import { useMutation, useQueryClient } from '@tanstack/react-query'
import { apiRequest } from '@/shared/api'

// Инвалидация — весь namespace документов (detail + листинг владельца).
function invalidate(qc: ReturnType<typeof useQueryClient>) {
  void qc.invalidateQueries({ queryKey: ['document'] })
}

// Согласовать версию (только заказчик, только последняя).
export function useApproveDocument(documentId: string) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (versionNumber: number) =>
      apiRequest({
        method: 'POST',
        url: `/documents/${documentId}/approve`,
        body: { version_number: versionNumber },
      }),
    onSuccess: () => invalidate(qc),
  })
}

export function useRevokeApproval(documentId: string) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: () =>
      apiRequest({ method: 'POST', url: `/documents/${documentId}/revoke-approval` }),
    onSuccess: () => invalidate(qc),
  })
}
